import News from '../components/Routes/News.vue'
import Film from '../components/Routes/Film.vue'
import NotFound from '../components/Routes/NotFound.vue'

const routes = [
  { path: '/', component: News },
  { path: '/film/:slug', component: Film },
  { path: '*', component: NotFound }
]

export default routes
